/**
 * @license
 * Copyright 2022 Aglyn LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

export enum FieldComponentType {
  /** Per-breakpoint span/offset row; persists one string (AGL-2486). */
  BREAKPOINT_SPAN = 'breakpoint-span',
  BUTTON = 'button',
  CHECKBOX = 'checkbox',
  COLOR_PICKER = 'color-picker',
  /** Thickness + line style for a border shorthand; one string (AGL-2486). */
  CSS_BORDER = 'css-border',
  /** Number + unit editor for a CSS length; persists one string (AGL-1219). */
  CSS_DIMENSION = 'css-dimension',
  /** Fill type + angle + colour stops; persists one CSS string (AGL-1331). */
  CSS_GRADIENT = 'css-gradient',
  /** Row-and-column grid for the Table element (AGL-2543). */
  DATA_TABLE = 'data-table',
  DATE_PICKER = 'date-picker',
  DUAL_LIST_SELECT = 'dual-list-select',
  FIELD_ARRAY = 'field-array',
  ICON_PICKER = 'icon-picker',
  INPUT_ADDON_BUTTON_GROUP = 'input-addon-button-group',
  INPUT_ADDON_GROUP = 'input-addon-group',
  PLAIN_TEXT = 'plain-text',
  /** Named presets with a raw escape hatch (AGL-2486). */
  PRESET_CHOICE = 'preset-choice',
  RADIO = 'radio',
  SELECT = 'select',
  SLIDER = 'slider',
  SUB_FORM = 'sub-form',
  SWITCH = 'switch',
  TAB_ITEM = 'tab-item',
  TABS = 'tabs',
  TEXT_FIELD = 'text-field',
  TEXTAREA = 'textarea',
  /** Theme-scale combo box that still accepts a raw value (AGL-2486). */
  THEME_SCALE = 'theme-scale',
  TIME_PICKER = 'time-picker',
  TOGGLE_BUTTON = 'toggle-button',
  /** Open/closed switch and from/to times per weekday; one hours string. */
  WEEKLY_HOURS = 'weekly-hours',
  WIZARD = 'wizard',
}

export enum FieldValidatorType {
  EXACT_LENGTH = 'exact-length',
  MAX_LENGTH = 'max-length',
  MAX_NUMBER_VALUE = 'max-number-value',
  MIN_ITEMS = 'min-items',
  MIN_LENGTH = 'min-length',
  MIN_NUMBER_VALUE = 'min-number-value',
  PATTERN = 'pattern',
  REQUIRED = 'required',
  URL = 'url',
}

export enum FieldDataType {
  BOOLEAN = 'boolean',
  FLOAT = 'float',
  INTEGER = 'integer',
  NUMBER = 'number',
  STRING = 'string',
}
